// PostHog's lifecycle under Statistics consent, as pure transitions so
// node --test can cover them. posthogService applies the side effects.
//
//   Uninitialized: posthog.init has never run; nothing is stored or sent.
//   Capturing:     initialised and opted in.
//   Suspended:     initialised, then consent was withdrawn: opted out, and
//                  persistence disabled so its cookies and storage are gone.
export const PostHogStatus = {
    Uninitialized: 'uninitialized',
    Capturing: 'capturing',
    Suspended: 'suspended',
};
export const PostHogAction = {
    None: 'none',
    Init: 'init',
    Resume: 'resume',
    Suspend: 'suspend',
};
export const planPostHogTransition = (status, statisticsGranted) => {
    if (statisticsGranted) {
        if (status === PostHogStatus.Uninitialized) {
            return PostHogAction.Init;
        }
        return status === PostHogStatus.Suspended ? PostHogAction.Resume : PostHogAction.None;
    }
    return status === PostHogStatus.Capturing ? PostHogAction.Suspend : PostHogAction.None;
};
export const statusAfter = (status, action) => {
    switch (action) {
        case PostHogAction.Init:
        case PostHogAction.Resume:
            return PostHogStatus.Capturing;
        case PostHogAction.Suspend:
            return PostHogStatus.Suspended;
        default:
            return status;
    }
};
// The before_send gate: only a capturing instance sends anything. Covers the
// gaps opt-out alone leaves, such as posthog.reset() clearing the opt-out flag.
export const mayCapture = (status) => status === PostHogStatus.Capturing;
